import React from "react";

function clean(value) {
  return value == null
    ? ""
    : String(value).trim();
}

export default function ProjectBreadcrumbTrail({
  onNavigatePage,
  lang = "en",
  pageKey = "projectHub",
  projectTitle = "",
  projectCategory = "story",
}) {
  const isFR =
    String(lang || "en")
      .trim()
      .toLowerCase()
      .startsWith("fr");

  const labels = {
    projectHub: isFR
      ? "HUB DE PROJETS"
      : "PROJECT HUB",

    myProjects: isFR
      ? "MES PROJETS"
      : "MY PROJECTS",

    createNovelStory: isFR
      ? "CRÉER UN NOUVEAU ROMAN / HISTOIRE"
      : "CREATE A NEW NOVEL / STORY",

    childrensBook: isFR
      ? "LIVRE POUR ENFANTS"
      : "CHILDREN’S BOOK",

    textbook: isFR
      ? "MANUEL SCOLAIRE"
      : "TEXTBOOK",

    textbookBlueprintOverview: isFR
      ? "VUE D’ENSEMBLE"
      : "OVERVIEW",

    textbookProjectOverview: isFR
      ? "PLAN DU PROJET"
      : "PROJECT PLAN",

    textbookBookMap: isFR
      ? "STRUCTURE DU LIVRE"
      : "BOOK STRUCTURE",

    textbookWriteChapters: isFR
      ? "RÉDIGER LES CHAPITRES"
      : "WRITE CHAPTERS",

    textbookChapterWorkspace: isFR
      ? "ESPACE CHAPITRE"
      : "CHAPTER WORKSPACE",

    screenplay: isFR
      ? "SCÉNARIO"
      : "SCREENPLAY",

    screenplayProjectOverview: isFR
      ? "VUE D’ENSEMBLE DU PROJET"
      : "PROJECT OVERVIEW",

    screenplayStoryMap:
      "STORY MAP",

    screenplayScriptWorkspace:
      "SCRIPT WORKSPACE",

    screenplayProposalRound: isFR
      ? "TOUR DE PROPOSITIONS"
      : "PROPOSAL ROUND",

    screenplayReviewAndDecide: isFR
      ? "EXAMINER ET DÉCIDER"
      : "REVIEW AND DECIDE",

    bookBlueprint: isFR
      ? "NEXTSCENES BOOK BLUEPRINT"
      : "NEXTSCENES BOOK BLUEPRINT",

    writerStudio: "WRITER STUDIO",
    storyDashboard: "STORY DASHBOARD",

    editorialBoard: isFR
      ? "COMITÉ ÉDITORIAL"
      : "EDITORIAL BOARD",
  };

  const title = clean(projectTitle);

  const projectHubItem = {
    label: labels.projectHub,
    page:
      pageKey === "projectHub"
        ? null
        : "projectHub",
  };

  const myProjectsItem = {
    label: labels.myProjects,
    page:
      pageKey === "myProjects"
        ? null
        : "projectHub",
    options: {
      projectCategory:
        clean(projectCategory) ||
        "story",

      source:
        "shared_project_breadcrumb",
    },
  };

  let items = [];

  if (pageKey === "projectHub") {
    items = [projectHubItem];
  } else if (pageKey === "myProjects") {
    items = [
      projectHubItem,
      myProjectsItem,
    ];
  } else if (pageKey === "createNovelStory") {
    items = [
      projectHubItem,
      myProjectsItem,
      {
        label: labels.createNovelStory,
        page: null,
      },
    ];
  } else if (
    pageKey === "childrensBook"
  ) {
    items = [
      projectHubItem,
      myProjectsItem,
      {
        label:
          labels.childrensBook,
        page: null,
      },
    ];
  } else if (
    pageKey === "bookBlueprint"
  ) {
    items = [
      projectHubItem,
      myProjectsItem,
      {
        label:
          labels.childrensBook,
        page: "projectHub",
        options: {
          projectCategory:
            "children",
          source:
            "childrens_book_breadcrumb",
        },
      },

      ...(title
        ? [
            {
              label:
                title.toUpperCase(),
              page: null,
            },
          ]
        : []),

      {
        label:
          labels.bookBlueprint,
        page: null,
      },
    ];
  } else if (
    pageKey === "textbook"
  ) {
    items = [
      projectHubItem,
      {
        label:
          labels.myProjects,
        page:
          "projectHub",
        options: {
          projectCategory:
            "",
          source:
            "textbook_breadcrumb",
        },
      },
      {
        label:
          labels.textbook,
        page: null,
      },
    ];
  } else if (
    pageKey ===
      "textbookBlueprintOverview" ||
    pageKey ===
      "textbookProjectOverview" ||
    pageKey ===
      "textbookBookMap" ||
    pageKey ===
      "textbookWriteChapters" ||
    pageKey ===
      "textbookChapterWorkspace"
  ) {
    items = [
      projectHubItem,
      {
        label:
          labels.myProjects,
        page:
          "projectHub",
        options: {
          projectCategory:
            "",
          source:
            "textbook_breadcrumb",
        },
      },
      {
        label:
          labels.textbook,
        page:
          "projectHub",
        options: {
          projectCategory:
            "textbook",
          source:
            "textbook_breadcrumb",
        },
      },

      ...(title
        ? [
            {
              label:
                title.toUpperCase(),
              page: null,
            },
          ]
        : []),

      {
        label:
          labels[pageKey],
        page: null,
      },
    ];
  } else if (
    pageKey === "screenplay"
  ) {
    items = [
      projectHubItem,
      {
        label:
          labels.myProjects,
        page:
          "projectHub",
        options: {
          projectCategory:
            "",
          source:
            "screenplay_breadcrumb",
        },
      },
      {
        label:
          labels.screenplay,
        page: null,
      },
    ];
  } else if (
    pageKey ===
      "screenplayProjectOverview" ||
    pageKey ===
      "screenplayStoryMap" ||
    pageKey ===
      "screenplayScriptWorkspace" ||
    pageKey ===
      "screenplayProposalRound" ||
    pageKey ===
      "screenplayReviewAndDecide"
  ) {
    items = [
      projectHubItem,
      {
        label:
          labels.myProjects,
        page:
          "projectHub",
        options: {
          projectCategory:
            "",
          source:
            "screenplay_breadcrumb",
        },
      },
      {
        label:
          labels.screenplay,
        page:
          "projectHub",
        options: {
          projectCategory:
            "screenplay",
          source:
            "screenplay_breadcrumb",
        },
      },

      ...(title
        ? [
            {
              label:
                title.toUpperCase(),
              page: null,
            },
          ]
        : []),

      {
        label:
          labels[pageKey],
        page: null,
      },
    ];
  } else {
    items = [
      projectHubItem,
      myProjectsItem,
    ];

    if (title) {
      items.push({
        label: title.toUpperCase(),
        page: null,
      });
    }

    items.push({
      label:
        labels[pageKey] ||
        clean(pageKey).toUpperCase(),
      page: null,
    });
  }

  return (
    <nav
      className="ns-breadcrumb-trail"
      aria-label={
        isFR
          ? "Fil d’Ariane du projet"
          : "Project breadcrumb"
      }
    >
      {items.map((item, index) => (
        <React.Fragment
          key={`${item.label}-${index}`}
        >
          {index > 0 ? (
            <span className="ns-breadcrumb-separator">
              /
            </span>
          ) : null}

          {item.page && onNavigatePage ? (
            <button
              className="ns-breadcrumb-link"
              type="button"
              onClick={() =>
                onNavigatePage(
                  item.page,
                  item.options
                )
              }
            >
              {item.label}
            </button>
          ) : (
            <span className="ns-breadcrumb-current">
              {item.label}
            </span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}
